import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_qc52eyp465: FaireCollectionEntity = {
  token: "pbc_qc52eyp465",
  type: "collection",
  name: "In-Stock Baby Coveralls & Jumpsuits (Sweater Knits)",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d073e4ef14425ccaeb7711f16d89a769b5c33ead8598dc7edb4b69e4d626ddca.png",
  itemCount: 42,
  description:
    "Explore our in-stock collection of organic cotton baby coveralls and jumpsuits in soft sweater knits. Ready to ship, these cozy one-piece styles feature charming details, breathable comfort, and lasting quality for everyday wear and thoughtful gifting.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:19.468Z",
    importedBy: "entity-db-import-collections",
  },
};
